import Multiselect from 'multiselect-react-dropdown';
import {
    MULTISELECT_COMMON_PROPS,
    MULTISELECT_THEME_STYLE,
} from '../constants/multiselectTheme';
import './MultiselectWithSelectAll.css';

/**
 * Multiselect with Select all / Clear controls.
 * Forwards the same onSelect/onRemove(selectedList) contract as multiselect-react-dropdown.
 */
function MultiselectWithSelectAll({
    options = [],
    selectedValues = [],
    onSelect,
    onRemove,
    placeholder,
    style = MULTISELECT_THEME_STYLE,
    selectAllLabel = 'Select all',
    clearLabel = 'Clear',
    disabled = false,
    className = '',
    ...rest
}) {
    const selectedCount = Array.isArray(selectedValues) ? selectedValues.length : 0;
    const optionsCount = Array.isArray(options) ? options.length : 0;
    const allSelected = optionsCount > 0 && selectedCount >= optionsCount;

    const handleSelectAll = () => {
        if (disabled || optionsCount === 0 || allSelected) return;
        onSelect?.(options);
    };

    const handleClear = () => {
        if (disabled || selectedCount === 0) return;
        onRemove?.([]);
    };

    return (
        <div className={`themed-multiselect multiselect-with-select-all ${className}`.trim()}>
            <div className="multiselect-select-all-bar">
                <button
                    type="button"
                    className="multiselect-select-all-btn"
                    onClick={handleSelectAll}
                    disabled={disabled || optionsCount === 0 || allSelected}
                >
                    {selectAllLabel}
                    {optionsCount > 0 ? ` (${optionsCount})` : ''}
                </button>
                {selectedCount > 0 && (
                    <button
                        type="button"
                        className="multiselect-select-all-btn"
                        onClick={handleClear}
                        disabled={disabled}
                    >
                        {clearLabel}
                    </button>
                )}
            </div>
            <Multiselect
                options={options}
                selectedValues={selectedValues}
                onSelect={onSelect}
                onRemove={onRemove}
                placeholder={placeholder}
                disable={disabled}
                {...MULTISELECT_COMMON_PROPS}
                {...rest}
                style={style}
            />
        </div>
    );
}

export default MultiselectWithSelectAll;
